<template>
    <div class="main">
        <div class="home">
            <div id="dne"></div>
            <Header :dataSource="PageEntity" />

            <div id="confirmEmail">
                <section class="confirm-email">
                    <div class="load load-white load-200" v-if="!showContent"></div>

                    <div class="container" v-if='showContent && (errorsGet.dataInvite != false && errorsGet.dataInvite != "invalid_invite")'>
                        <div class="box-error">
                            <h3 class="title-secondary">{{ getMyLanguage("box-error", "title-error") }}</h3>
                            <p>{{ getMyLanguage("box-error", errorsGet.dataInvite) }}</p>
                            <div class="cod-error">
                                Cód.: {{errorsGet.dataInvite}}
                            </div>
                        </div>
                    </div>

                    <!-- INVALID -->
                    <div class="container" v-if='showContent && errorsGet.dataInvite === "invalid_invite"'>
                        <div class="box-success">
                            <h3 class="title-secondary">{{ getMyLanguage("invite","invite.registered.title") }}</h3>
                            <p v-html='getMyLanguage("invite","invite.registered.txt-01")'></p>

                            <div class="resend">
                                <p v-html='getMyLanguage("invite","invite.registered.txt-02")'></p>

                                <div class="bts">
                                    <div class="btn-primary" v-if="!resendLoad" @click='resendMsg("email")'>{{ getMyLanguage("invite","invite.email-send") }}</div>
                                    <div class="btn-primary" v-if="!resendLoad" @click='resendMsg("sms")'>{{ getMyLanguage("sms","sms.send") }}</div>
                                    
                                    <div class="resendLoad" v-if="resendLoad"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- FINISHED -->
                    <div class="container" v-if='showContent && dataInvite.invite_status === "Finished"'>
                        <div class="box-success">
                            <h3 class="title-secondary">{{ getMyLanguage("invite","invite.finished.title") }}</h3>

                            <div class="resend">
                                <p v-html='getMyLanguage("invite","invite.finished.txt-01")'></p>

                                <div class="bts">
                                    <a :href="`/${flagSelected}/account/login`" class="btn-primary btn-login"><span>{{ getMyLanguage("login", "login.sign-in") }}</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- ERROR RESTRICTED -->
                    <div class="container" v-if='showContent && errorsPost.newInvite === "not_allowed_restricted_country_pep"'>
                        <div class="box-error">
                            <h3 class="title-secondary">{{ getMyLanguage("box-error", "title-error") }}</h3>
                            <p v-html='getMyLanguage("box-error","not_allowed_restricted_country_pep")'></p>
                            <!-- <div class="cod-error">
                                Cód.: {{errorsGet.dataInvite}}
                            </div> -->
                        </div>
                    </div>

                    <div class="container" v-if='showContent && !errorsGet.dataInvite && !errorsPost.newInvite && dataInvite.invite_status != "Finished"'>
                        <div class="row">
                            <div class="col-12 col-lg-6">

                                <h2 class="title-secondary">{{ getMyLanguage("invite", "invite.title") }}</h2>
                                
                                <div class="box-confirm-email">                                   
                                    <!-- BOX REGISTRATION -->
                                    <div class="box-registration" :class="{dropListOpened: (dropListOpened.languageCompany || dropListOpened.countryCompany || dropListOpened.ddiCompany || dropListOpened.languagePerson || dropListOpened.countryPerson || dropListOpened.ddiPerson)}">
                                        <div class="msg" v-html='getMyLanguage("invite", "invite.msg")'></div>

                                        <div class="formBox">

                                            <!-- INVITE COMPANY -->
                                            <div class="invite-company" v-if='dataInvite.invite_type_code === "company_invite"'>
                                                <div class="anc anc-company" id="!company"></div>

                                                <h3>{{getMyLanguage("purchase-token","purchase-token.content.box-register.subtitle.companyData")}}</h3>
                                                <label class="formFullName">
                                                    <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.companyName") }}</span>
                                                    <input v-model="newInvite.companyInvite.fullName" type="text" class="form" :class='{error: errorForm.companyInvite.fullName}' @keydown="errorForm.companyInvite.fullName = false" maxlength="80" autocomplete="off" >
                                                </label>
                                                <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.fullName'>{{getMyLanguage("errors","errors.nameError")}}</p>
                                                

                                                <!-- EMAIL COMPANY -->
                                                <label class="formYourEmail">
                                                    <span class="ph">{{ getMyLanguage("purchase-token","purchase-token.content.box-register.placeholder.companyEmail") }}</span>
                                                    <input v-model="validateEmail.company.val" onpaste="return false;" @blur='regexEmail("company")' @keyup='checkEmail("company")' type="email" class="form formYourEmail" :class='{error: (errorForm.companyInvite.email || errorsPost.newInvite === "account_activate_email_already_exists" || validateEmail.company.regex === false)}' @keydown="errorForm.companyInvite.email = false" maxlength="60" autocomplete="off">
                                                </label>
                                                <p class="msg-validate-form msg-error anime" :class="{invalidated: validateEmail.company.regex}" v-if='validateEmail.company.regex === false || errorForm.companyInvite.email'>{{getMyLanguage("errors","errors.emailError")}}</p>
                                                
                                                <label class="formYourEmail">
                                                    <span class="ph">{{ getMyLanguage("client-space","client-space.account.lbl.repeatEmail") }}</span>
                                                    <input v-model="newInvite.companyInvite.email" onpaste="return false;" @keyup='checkEmail("company")' type="email" id="email" class="form formYourEmail" :class='{error: (errorForm.companyInvite.email || errorsPost.newInvite === "account_activate_email_already_exists"), warning: validateEmail.company.status === false}' maxlength="60" autocomplete="off">
                                                </label>
                                                <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.company.status, invalidated: validateEmail.company.status}" v-if='validateEmail.company.status === false'>{{getMyLanguage("errors","errors.emailRepeatError")}}</p>
                                                <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.company.status, invalidated: validateEmail.company.status}" v-if='errorsPost.newInvite === "account_activate_email_already_exists"'>{{getMyLanguage("errors","errors.emailRegistered")}}</p>

                                                <!-- LANGUAGE COMPANY -->
                                                <div class="autocomplete formLanguage" :class="{opened: dropListOpened.languageCompany}">
                                                    <div class="openAutocomplete" v-if="!listLanguagesCompanyStatus" @click="dropListLanguagesCompany(true)"></div>
                                                    <div class="closeAutocomplete closeDropListCountry" v-if="listLanguagesCompanyStatus" v-on:click="dropListLanguagesCompany(false)"></div>

                                                    <label>
                                                        <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.language") }}</span>
                                                        <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedLanguageCompanyFlag}/flags`" class="flag-selected" v-if="selectedLanguageCompanyFlag != false">
                                                        <input type="text" id="languageCompanyID" class="form" :class="{selected: selectedLanguageCompanyFlag != false, error: errorForm.companyInvite.languageId}" @focus="dropListLanguagesCompany(true)" v-on:keyup="filterListLanguageCompany" @blur="dropListLanguagesCompany(false)" @keydown.esc="dropListLanguagesCompany(false)" :value="languagesList(selectedLanguageCompany.code)" autocomplete="off">
                                                    </label>
                                                    <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.languageId'>{{getMyLanguage("errors","errors.language")}}</p>

                                                    <ul id="drop-list-company" v-if="listLanguagesCompanyStatus">
                                                        <li v-for="(itemList,index) in langsTranslated" :key="index" v-on:click="(newInvite.companyInvite.languageId = itemList.id),(selectedLanguageCompany.code = itemList.code),(selectedLanguageCompanyFlag = itemList.flag), (dropListLanguagesCompany(false)), errorForm.companyInvite.languageId = false">
                                                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemList.flag}/flags`">
                                                            <a>{{ languagesList(itemList.code) }}</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <!-- COUNTRY COMPANY -->
                                                <div class="autocomplete formResidenceCountry" :class="{opened: dropListOpened.countryCompany}">
                                                    <div class="openAutocomplete" v-if="!listCountryCompanyStatus" @click="dropListCountryCompany(true)"></div>
                                                    <div class="closeAutocomplete closeDropListCountry" v-if="listCountryCompanyStatus" v-on:click="dropListCountryCompany(false)"></div>

                                                    <label>
                                                        <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.residence") }}</span>
                                                        <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryFlagCompany}/flags`" class="flag-selected" v-if="selectedCountryFlagCompany != false">
                                                        <input type="text" id="residenceCompanyCountry" class="form" :class="{selected: selectedCountryFlagCompany != false, error: errorForm.companyInvite.countryId}" @focus="dropListCountryCompany(true)" @blur="dropListCountryCompany(false)" @keydown.esc="dropListCountryCompany(false)" v-on:keyup="filterListCountryCompany" :value="countryTranslate(selectedCountryCompany.IsoCode)" autocomplete="off">
                                                    </label>
                                                    <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.countryId'>{{getMyLanguage("errors","errors.residenceError")}}</p>

                                                    <ul id="drop-list" v-if="listCountryCompanyStatus">
                                                        <li v-for="(itemListCompany,index) in countriesTranslated" :key="index" v-on:click="(newInvite.companyInvite.countryId = itemListCompany.Id), (newInvite.companyInvite.phoneCountryId = itemListCompany.Id), (this.changeMaskCompany()), (selectedCountryFlagCompany = itemListCompany.Flag), (selectedCountryDDICompany.countrySelected = true), (selectedCountryDDICompany.active = 'active'), (selectedCountryDDICompany.phoneMask = itemListCompany.PhoneMask), (selectedCountryDDICompany.ddi = itemListCompany.DDI), (selectedCountryDDICompany.flag = itemListCompany.Flag), (selectedCountryCompany.IsoCode = itemListCompany.IsoCode), (dropListCountryCompany(false)), errorForm.companyInvite.countryId = false">
                                                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemListCompany.Flag}/flags`">
                                                            <a>{{ countryTranslate(itemListCompany.IsoCode)}}</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <!-- PHONE COMPANY -->
                                                <div class="formPhone" :class='{opened: dropListOpened.ddiCompany, active: selectedCountryDDICompany.active, error: (errorsPost.newInvite === "account_activate_phone_already_exists" || errorForm.companyInvite.phoneNumber)}'>
                                                    <label>
                                                        <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.companyPhone") }}</span>
                                                    </label>

                                                    <div class="d-flex">
                                                        <div class="select-ddi" id="selectDDICompany" v-if="selectedCountryDDICompany.countrySelected && selectedCountryDDICompany.changeMask">
                                                            <div class="open-select-ddi" @click="dropListDDICompany(true)"></div>
                                                            <div class="close-select-ddi" v-if="selectedCountryDDICompany.openSelect" @click="dropListDDICompany(false)"></div>
                                                            <div class="selected-ddi">
                                                                <div class="flag">
                                                                    <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryDDICompany.flag}/flags`" v-if="selectedCountryDDICompany.flag != ''">
                                                                </div>
                                                                <span class="ddi">+{{selectedCountryDDICompany.ddi}}</span>
                                                            </div>
                                                            <ul class="list-ddi" v-if="selectedCountryDDICompany.openSelect">
                                                                <div class="scroll">
                                                                    <li v-for="(ddiList,index) in countriesTranslated" :key="index" @click='(newInvite.companyInvite.phoneCountryId = ddiList.Id), (selectedCountryDDICompany.phoneMask = ddiList.PhoneMask), (this.changeMaskCompany()), (selectedCountryDDICompany.ddi = ddiList.DDI), (selectedCountryDDICompany.flag = ddiList.Flag), (dropListDDICompany(false)), (newInvite.companyInvite.phoneNumber = "")'>
                                                                        <div class="flag">
                                                                            <img class="anime" :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${ddiList.Flag}/flags`">
                                                                        </div>
                                                                        <span class="name-country">{{ countryTranslate(ddiList.IsoCode) }}</span>
                                                                        <span class="ddi" >(+{{ddiList.DDI}})</span>
                                                                    </li>
                                                                </div>
                                                            </ul>
                                                        </div>

                                                        <label v-if="selectedCountryDDICompany.changeMask">
                                                            <input v-model="validatePhone.company.val" id="phoneNumberCompany" type="text" class="form" v-mask="selectedCountryDDICompany.phoneMask" @keydown="errorForm.companyInvite.phoneNumber = false" @blur='regexPhone("company"), selectedCountryDDICompany.openSelect = false' maxlength="25" autocomplete="off" >
                                                        </label>
                                                    </div>

                                                    <div class="form load-phone" v-if="!selectedCountryDDICompany.changeMask"></div>
                                                </div>
                                                <p class="msg-validate-form msg-error anime" v-if='validatePhone.company.regex === false || errorForm.companyInvite.phoneNumber'>{{getMyLanguage("errors","errors.phoneError")}}</p>
                                                <p class="msg-validate-form msg-error anime" v-if='errorsPost.newInvite === "account_activate_phone_already_exists"'>{{getMyLanguage("errors","errors.phoneRegistered")}}</p>

                                                <label class="formTaxNumber">
                                                    <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.companyTaxNumber") }}</span>
                                                    <input v-model="newInvite.companyInvite.taxNumber" type="text" class="form" :class="{error: errorForm.companyInvite.taxNumber}" @keydown="errorForm.companyInvite.taxNumber = false" maxlength="80" autocomplete="off" >
                                                </label>
                                                <p class="msg-validate-form msg-error anime" v-if='errorForm.companyInvite.taxNumber'>{{getMyLanguage("errors","errors.taxNumber")}}</p>


                                                <!-- ERRORS COMPANY -->
                                                <!-- <div class="msgError errorsCompany">
                                                    <span class="nameError">{{ getMyLanguage("errors", "errors.nameError") }}</span>
                                                    <span class="emailError">{{ getMyLanguage("errors", "errors.emailError") }}</span>
                                                    <span class="residenceError">{{ getMyLanguage("errors", "errors.residenceError") }}</span>
                                                    <span class="phoneError">{{ getMyLanguage("errors", "errors.phoneError") }}</span>
                                                    <span class="taxNumberError">{{ getMyLanguage("errors", "errors.taxNumber") }}</span>
                                                    <span class="email_existe" v-if='errorsPost.newInvite === "account_activate_email_already_exists"'>{{ getMyLanguage("box-error", "account_activate_email_already_exists")}}</span>
                                                    <span class="phone_existe" v-if='errorsPost.newInvite === "account_activate_phone_already_exists"'>{{ getMyLanguage("box-error", "account_activate_phone_already_exists")}}</span>
                                                </div> -->
                                            </div>


                                            <!-- INVITE PERSON -->
                                            <div class="invite-person">
                                                <div class="anc anc-company" id="!person"></div>

                                                <h3 v-if='dataInvite.invite_type_code === "company_invite"'>{{getMyLanguage("purchase-token","purchase-token.content.box-register.subtitle.partnerData")}}</h3>

                                                <!-- <div class="form-group-check formPEP">
                                                    <input type="checkbox" id="checkPEP" class="form-check" v-model="newInvite.pep">
                                                    <label for="checkPEP" class="form-check-label"><small>{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.check-pep")}}</small></label>
                                                </div> -->


                                                <div class="check-pep">
                                                    <p>{{getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.check-pep")}}</p>

                                                    <div class="form-group-radio">
                                                        <input type="radio" v-model="newInvite.pep" id="pepTrue" :value="true" name="radioPEP" class="form-radio" @click='newInvite.pep = true' :checked='newInvite.pep' >
                                                        <label for="pepTrue" class="form-radio-label">
                                                            <span>{{getMyLanguage("client-space","client-space.account.modal.btn-yes")}}</span>
                                                        </label>

                                                        <input type="radio" v-model="newInvite.pep" id="pepFalse" :value="false" name="radioPEP" class="form-radio" @click="newInvite.pep = false" :checked='!newInvite.pep' >
                                                        <label for="pepFalse" class="form-radio-label">
                                                            <span>{{getMyLanguage("client-space","client-space.account.modal.btn-no")}}</span>
                                                        </label>
                                                    </div>

                                                    <p class="alert" v-if="newInvite.pep">{{getMyLanguage("purchase-token","purchase-token.content.box-register.alert.check-pep")}}</p>
                                                </div>

                                                <label class="formFullName">
                                                    <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.fullname") }}</span>
                                                    <input v-model="newInvite.fullName" type="text" class="form" :class="{error: errorForm.personInvite.fullName}" @keydown="errorForm.personInvite.fullName = false" maxlength="80" autocomplete="off" >
                                                </label>
                                                <p class="msg-validate-form msg-error anime" v-if='errorForm.personInvite.fullName'>{{getMyLanguage("errors","errors.nameError")}}</p>


                                                <!-- EMAIL -->
                                                <label class="formYourEmail">
                                                    <span class="ph">{{ getMyLanguage("client-space","client-space.account.lbl.email") }}</span>
                                                    <input v-model="validateEmail.person.val" onpaste="return false;" @blur='regexEmail("person")' @keyup='checkEmail("person")' @keydown="errorForm.personInvite.email = false" type="email" class="form formYourEmail" :class='{error: (errorForm.personInvite.email || errorsPost.newInvite === "account_activate_email_already_exists" || errorForm.personInviteemail)}' maxlength="60" autocomplete="off">
                                                </label>
                                                <p class="msg-validate-form msg-error anime" :class="{invalidated: validateEmail.person.regex}" v-if='validateEmail.person.regex === false || errorForm.personInvite.email'>{{getMyLanguage("errors","errors.emailError")}}</p>

                                                <label class="formYourEmail">
                                                    <span class="ph">{{ getMyLanguage("client-space","client-space.account.lbl.repeatEmail") }}</span>
                                                    <input v-model="newInvite.email" onpaste="return false;" @keyup='checkEmail("person")' type="email" id="email" class="form formYourEmail" :class='{error: (errorForm.personInvite.email || errorsPost.newInvite === "account_activate_email_already_exists")}' maxlength="60" autocomplete="off">
                                                </label>
                                                <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.person.status, invalidated: validateEmail.person.status}" v-if='validateEmail.person.status === false'>{{getMyLanguage("errors","errors.emailRepeatError")}}</p>
                                                <p class="msg-validate-form msg-warning anime" :class="{validated: validateEmail.person.status, invalidated: validateEmail.person.status}" v-if='errorsPost.newInvite === "account_activate_email_already_exists"'>{{getMyLanguage("errors","errors.emailRegistered")}}</p>


                                                <!-- LANGUAGE -->
                                                <div class="autocomplete formLanguage" :class="{opened: dropListOpened.languagePerson}">
                                                    <div class="openAutocomplete" v-if="!listLanguagesStatus" @click="dropListLanguages(true)"></div>
                                                    <div class="closeAutocomplete closeDropListCountry" v-if="listLanguagesStatus" v-on:click="dropListLanguages(false)"></div>

                                                    <label>
                                                        <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.language") }}</span>
                                                        <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedLanguageFlag}/flags`" class="flag-selected" v-if="selectedLanguageFlag != false">
                                                        <input type="text" id="languageID" class="form" :class="{selected: selectedLanguageFlag != false, error: errorForm.personInvite.languageId}" @focus="dropListLanguages(true)" v-on:keyup="filterListLanguage" @blur="dropListLanguages(false)" @keydown.esc="dropListLanguages(false)" :value="languagesList(selectedLanguage.code)" autocomplete="off">
                                                    </label>
                                                    <p class="msg-validate-form msg-error anime" v-if='errorForm.personInvite.languageId'>{{getMyLanguage("errors","errors.language")}}</p>

                                                    <ul id="drop-list" v-if="listLanguagesStatus">
                                                        <li v-for="(itemList,index) in langsTranslated" :key="index" v-on:click="(newInvite.languageId = itemList.id),(selectedLanguage.code = itemList.code),(selectedLanguageFlag = itemList.flag), (dropListLanguages(false)), errorForm.personInvite.languageId = false">
                                                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemList.flag}/flags`">
                                                            <a>{{ languagesList(itemList.code) }}</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <!-- COUNTRY -->
                                                <div class="autocomplete formResidenceCountry" :class="{opened: dropListOpened.countryPerson}">
                                                    <div class="openAutocomplete" v-if="!listCountryStatus" @click="dropListCountry(true)"></div>
                                                    <div class="closeAutocomplete closeDropListCountry" v-if="listCountryStatus" v-on:click="dropListCountry(false)"></div>

                                                    <label>
                                                        <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.residence") }}</span>
                                                        <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryFlag}/flags`" class="flag-selected" v-if="selectedCountryFlag != false">
                                                        <input type="text" id="residenceCountry" class="form" :class="{selected: selectedCountryFlag != false, error: errorForm.personInvite.countryId}" @focus="dropListCountry(true)" @blur="dropListCountry(false)" @keydown.esc="dropListCountry(false)" v-on:keyup="filterListCountry" :value="countryTranslate(selectedCountry.IsoCode)" autocomplete="off">
                                                    </label>
                                                    <p class="msg-validate-form msg-error anime" v-if='errorForm.personInvite.countryId'>{{getMyLanguage("errors","errors.residenceError")}}</p>

                                                    <ul id="drop-list" v-if="listCountryStatus">
                                                        <li v-for="(itemList,index) in countriesTranslated" :key="index" v-on:click="(newInvite.countryId = itemList.Id), (newInvite.phoneCountryId = itemList.Id), (this.changeMask()), (selectedCountryFlag = itemList.Flag), (selectedCountryDDI.countrySelected = true), (selectedCountryDDI.active = 'active'), (selectedCountryDDI.phoneMask = itemList.PhoneMask), (selectedCountryDDI.ddi = itemList.DDI), (selectedCountryDDI.flag = itemList.Flag), (selectedCountry.IsoCode = itemList.IsoCode), (dropListCountry(false)), errorForm.personInvite.countryId = false">
                                                            <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${itemList.Flag}/flags`">
                                                            <a>{{ countryTranslate(itemList.IsoCode)}}</a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <!-- PHONE -->
                                                <div class="formPhone" :class='{opened: dropListOpened.ddiPerson, active: selectedCountryDDI.active, error: (errorsPost.newInvite === "account_activate_phone_already_exists" || errorForm.personInvite.phoneNumber)}'>
                                                    <label>
                                                        <span class="ph">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.placeholder.phone") }}</span>
                                                    </label>
                                                    
                                                    <div class="d-flex">
                                                        <div class="select-ddi" v-if="selectedCountryDDI.countrySelected && selectedCountryDDI.changeMask">
                                                            <div class="open-select-ddi" @click="dropListDDI(true)"></div>
                                                            <div class="close-select-ddi" v-if="selectedCountryDDI.openSelect" @click="dropListDDI(false)"></div>
                                                            <div class="selected-ddi">
                                                                <div class="flag">
                                                                    <img :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${selectedCountryDDI.flag}/flags`" v-if="selectedCountryDDI.flag != ''">
                                                                </div>
                                                                <span class="ddi">+{{selectedCountryDDI.ddi}}</span>
                                                            </div>
                                                            <ul class="list-ddi" v-if="selectedCountryDDI.openSelect">
                                                                <div class="scroll">
                                                                    <li v-for="(ddiList,index) in countriesTranslated" :key="index" @click='(newInvite.phoneCountryId = ddiList.Id), (selectedCountryDDI.phoneMask = ddiList.PhoneMask), (this.changeMask()), (selectedCountryDDI.ddi = ddiList.DDI), (selectedCountryDDI.flag = ddiList.Flag), (dropListDDI(false)), (newInvite.phoneNumber = "")'>
                                                                        <div class="flag">
                                                                            <img class="anime" :src="`https://imagedelivery.net/-5Lr2B91XIIGgp5YOFIoTg/${ddiList.Flag}/flags`">
                                                                        </div>
                                                                        <span class="name-country">{{ countryTranslate(ddiList.IsoCode) }}</span>
                                                                        <span class="ddi" >(+{{ddiList.DDI}})</span>
                                                                    </li>
                                                                </div>
                                                            </ul>
                                                        </div>

                                                        <label v-if="selectedCountryDDI.changeMask">
                                                            <input v-model="validatePhone.person.val" id="phoneNumber" type="text" class="form" v-mask="selectedCountryDDI.phoneMask" @keydown="errorForm.personInvite.phoneNumber = false" @blur='regexPhone("person")' maxlength="25" autocomplete="off" >
                                                        </label>
                                                    </div>

                                                    <div class="form load-phone" v-if="!selectedCountryDDI.changeMask"></div>
                                                </div>
                                                <p class="msg-validate-form msg-error regex-error anime" v-if='validatePhone.person.regex === false || errorForm.personInvite.phoneNumber'>{{getMyLanguage("errors","errors.phoneError")}}</p>
                                                <p class="msg-validate-form msg-error anime" v-if='errorsPost.newInvite === "account_activate_phone_already_exists"'>{{getMyLanguage("errors","errors.phoneRegistered")}}</p>
                                                

                                                <!-- ACCEPTS -->
                                                <div class="accepts">
                                                    <div class="form-group-check">
                                                        <input type="checkbox" id="acceptTerms" class="form-check" v-model="accept.terms">
                                                        <label for="acceptTerms" class="form-check-label" :class="{error: errorForm.acceptsInvite.acceptTerms}"><small>{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-terms") }}</small></label>
                                                        <a :href="`/${flagSelected}/terms-and-conditions`" target="_blank" class="lnk-terms-group-check">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-terms.lnk") }}</a>
                                                        <!-- <a :href='"/" + flagSelected + "/terms-and-conditions"' target="_blank" class="lnk-terms">{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.readTerms") }}</a> -->
                                                    </div>
                                                    
                                                    <div class="form-group-check">
                                                        <input type="checkbox" id="acceptNotify" class="form-check" v-model="accept.notify">
                                                        <label for="acceptNotify" class="form-check-label" :class="{error: errorForm.acceptsInvite.acceptNotify}"><small>{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-notify") }}</small></label>
                                                    </div>
                                                    
                                                    <div class="form-group-check">
                                                        <input type="checkbox" id="acceptGDPR" class="form-check" v-model="accept.gdpr">
                                                        <label for="acceptGDPR" class="form-check-label" :class="{error: errorForm.acceptsInvite.acceptGdpr}"><small>{{ getMyLanguage("purchase-token", "purchase-token.content.box-register.accept-gdpr") }}</small></label>
                                                    </div>
                                                </div>

                                                <div class="box-error" v-if="errorsPost.general != false">
                                                    <h3 class="title-secondary">{{ getMyLanguage("box-error", "title-error") }}</h3>
                                                    <p>{{ getMyLanguage("box-error","general-error") }}</p>
                                                    <div class="cod-error">
                                                        Cód.: {{errorsPost.general}}
                                                    </div>
                                                </div>

                                                <div id="btnRegister" v-if="!accept.terms || !accept.notify || !accept.gdpr" @click="validationFormInvite()" class="btn-primary btn-disabled">{{ getMyLanguage("invite", "invite.btn") }}</div>
                                                <div id="btnRegister" v-if="accept.terms && accept.notify && accept.gdpr && !load && !errorsPost.general" @click="validationFormInvite()" class="btn-primary">{{ getMyLanguage("invite", "invite.btn") }}</div>
                                                <div class="btn-primary load" v-if="load"></div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <Footer />
        <CookieConsent />
    </div>
</template>

<script>
    const $ = require('jquery')
    window.$ = $

    import Header from '@/components/Header.vue';
    import Footer from '@/components/Footer.vue';
    import CookieConsent from '@/components/CookieConsent.vue';

    import getMyContentLanguage from "@/services/contentLanguage.js";
    import langsList from "@/services/listLanguages.js";
    import countriesList from "@/services/listCountries.js";

    import apiPlatform from '@/config/apiPlatform.js'
  
    export default {
        components: {
            Header,
            Footer,
            CookieConsent
        },

        data(){
            return{
                showContent: false,
                load: false,
                PageEntity: "ecosystem",

                errorsGet: {
                    dataInvite: false
                },

                errorsPost: {
                    newInvite: false,
                    general: false
                },

                validateEmail: {
                    company: {
                        regex: '',
                        status: '',
                        val: ''
                    },

                    person: {
                        regex: '',
                        status: '',
                        val: ''
                    }
                },
                
                validatePhone: {
                    company: {
                        regex: '',
                        status: '',
                        val: ''
                    },

                    person: {
                        regex: '',
                        status: '',
                        val: ''
                    }
                },

                dataInvite: [],
                dataCountry: [],
                dataLanguage: [],
                langsTranslated: [],
                
                flagSelected: "en",
                showFlag: false,
                showFlagCompany: false,

                listLanguagesStatus: false,
                selectedLanguage: {},
                selectedLanguageFlag: false,
                
                listLanguagesCompanyStatus: false,
                selectedLanguageCompany: {},
                selectedLanguageCompanyFlag: false,

                listCountryStatus: false,
                selectedCountry: {},
                selectedCountryFlag: false,
                
                listCountryCompanyStatus: false,
                selectedCountryCompany: {},
                selectedCountryFlagCompany: false,
                
                selectedCountryDDICompany: {
                    changeMask: true,
                    phoneMask: '?',
                    countrySelected: false,
                    flag: ''
                },

                selectedCountryDDI: {
                    changeMask: true,
                    phoneMask: '?',
                    countrySelected: false,
                    flag: ''
                },

                dropListOpened: {
                    languageCompany: false,
                    countryCompany: false,
                    ddiCompany: false,

                    languagePerson: false,
                    countryPerson: false,
                    ddiPerson: false
                },

                newInvite: {
                    companyInvite: {},
                    
                    pep: false,
                    fullName: "",
                    email: "",
                    languageId: "",
                    countryId: "",
                    phoneCountryId: "",
                    phoneNumber: ""
                },

                errorForm: {
                    companyInvite: {},
                    personInvite: {},
                    acceptsInvite: {
                        acceptTerms: false,
                        acceptNotify: false,
                        acceptGdpr: false
                    },

                    company: false,
                    person: false,
                    accepts: false
                },

                accept: {
                    terms: false,
                    notify: false,
                    gdpr: false
                },

                resendLoad: false
            }
        },    
        
        async mounted(){
            await apiPlatform.get(`/api/v1/platform/account/invite/${this.$route.params.registerId}`)
            .then(response => {
                this.dataInvite = response.data

                if ( this.dataInvite.invite_type_code === "company_invite" ){
                    this.newInvite.companyInvite.fullName = "",
                    this.newInvite.companyInvite.email = "",
                    this.newInvite.companyInvite.languageId = "",
                    this.newInvite.companyInvite.countryId = "",
                    this.newInvite.companyInvite.phoneCountryId = "",
                    this.newInvite.companyInvite.phoneNumber = "",
                    this.newInvite.companyInvite.taxNumber = ""
                }
            })
            .catch(error => {
                this.errorsGet.dataInvite = error.response.data
            })
            
            await apiPlatform.get('/api/v1/platform/language/dne_ecosystem')
            .then(response => {
                this.dataLanguage = response.data
                
                setTimeout(() => {
                    this.orderLangs()
                }, 100);
            })
            .catch(error => {
                this.errorsGet.dataInvite = error.response.data
            })
            
            setTimeout(() => {
                this.showContent = true
            }, 500);


            // if ( this.dataInvite.invite_type_code === "company_invite" ){
            //     this.newInvite.companyInvite.languageId = this.$store.state.allLanguages.filter(lang => lang.code === this.$store.state.SelectLanguage.code)[0].id
            //     this.selectedLanguageCompany.name = this.$store.state.allLanguages.filter(lang => lang.code === this.$store.state.SelectLanguage.code)[0].name
            //     this.selectedLanguageCompanyFlag = this.$store.state.allLanguages.filter(lang => lang.code === this.$store.state.SelectLanguage.code)[0].flag
            // }

            // this.newInvite.languageId = this.$store.state.allLanguages.filter(lang => lang.code === this.$store.state.SelectLanguage.code)[0].id
            // this.selectedLanguage.name = this.$store.state.allLanguages.filter(lang => lang.code === this.$store.state.SelectLanguage.code)[0].name
            // this.selectedLanguageFlag = this.$store.state.allLanguages.filter(lang => lang.code === this.$store.state.SelectLanguage.code)[0].flag


            // COUNTRY
            await apiPlatform.get('api/v1/platform/country')
            .then(response => {
                this.dataCountry = response.data
                
                setTimeout(() => {
                    this.ordercountries()
                }, 100);
            })
            .catch(error => {
                this.errorsGet.dataInvite = error.response.data
            })

            setTimeout(() => {
                this.showContent = true
                this.newInvite.inviteId = this.dataInvite.invite_id
                // this.changeFlagLanguage(this.dataLanguage.filter(lang => lang.id === this.newInvite.languageId)[0].id)
            }, 500);
        },

        methods: {
            getMyLanguage(group, code){
                return getMyContentLanguage(group, code, this.$store.state.SelectLanguage.code)
            },

            languageSelected(){
                this.flagSelected = this.$store.state.SelectLanguage.code

                document.title = this.getMyLanguage("seo","title.account.invite");
                document.getElementsByTagName('meta')["description"].content = ''
            },


            // LANGUAGES
            languagesList(code){
                return langsList(code, this.$store.state.SelectLanguage.code)
            },

            orderLangs() {
                this.langsTranslated = [...this.dataLanguage];

                this.langsTranslated.forEach(lang => {
                    lang.translatedName = this.languagesList(lang.code);
                });

                this.langsTranslated.sort((a, b) => {
                    return a.translatedName.toLowerCase().localeCompare(b.translatedName.toLowerCase());
                });
            },


            // COUNTRIES
            countryTranslate(code){
                return countriesList(code, this.$store.state.SelectLanguage.code)
            },

            ordercountries() {
                this.countriesTranslated = [...this.dataCountry];

                this.countriesTranslated.forEach(lang => {
                    lang.translatedCountry = this.countryTranslate(lang.IsoCode);
                });

                this.countriesTranslated.sort((a, b) => {
                    return a.translatedCountry.toLowerCase().localeCompare(b.translatedCountry.toLowerCase());
                });
            },


            regexEmail(emailCheck){
                const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                if ( emailCheck === "company"){
                    if (regex.test(this.validateEmail.company.val)) {
                        this.validateEmail.company.regex = true
                    } else{
                        this.validateEmail.company.regex = false
                    }
                } else if ( emailCheck === "person"){
                    if (regex.test(this.validateEmail.person.val)) {
                        this.validateEmail.person.regex = true
                    } else{
                        this.validateEmail.person.regex = false
                    }
                }
            },

            checkEmail(emailCheck){
                if ( emailCheck === "company" ){
                    if ( this.validateEmail.company.val === this.newInvite.companyInvite.email ){
                        this.validateEmail.company.status = true
                    } else{
                        this.validateEmail.company.status = false
                    }
                } else if ( emailCheck === "person" ){
                    if ( this.validateEmail.person.val === this.newInvite.email ){
                        this.validateEmail.person.status = true
                    } else{
                        this.validateEmail.person.status = false
                    }
                }
            },

            regexPhone(phoneCheck){
                const regex = /^\+[1-9]\d{8,14}$/;

                if ( phoneCheck === "company"){
                    let phoneE164Company = this.selectedCountryDDICompany.ddi + this.validatePhone.company.val
                    phoneE164Company = "+" + phoneE164Company.replace(/[^0-9]/g,'')
                    
                    if (regex.test(phoneE164Company)) {
                        this.validatePhone.company.regex = true
                    } else{
                        this.validatePhone.company.regex = false
                    }
                } else if ( phoneCheck === "person"){
                    let phoneE164Person = this.selectedCountryDDI.ddi + this.validatePhone.person.val
                    phoneE164Person = "+" + phoneE164Person.replace(/[^0-9]/g,'')
                    
                    if (regex.test(phoneE164Person)) {
                        this.validatePhone.person.regex = true
                    } else{
                        this.validatePhone.person.regex = false
                    }
                }
            },

            changeFlagLanguage(value){
                this.showFlag = false
                this.newInvite.languageId = value

                this.showFlag = true
            },

            changeMaskCompany(){
                this.selectedCountryDDICompany.changeMask = false

                setTimeout(() => {
                    this.selectedCountryDDICompany.changeMask = true
                }, 1000);

                setTimeout(() => {
                    document.getElementById('phoneNumberCompany').focus()
                }, 1050);
            },

            changeMask(){
                this.selectedCountryDDI.changeMask = false

                setTimeout(() => {
                    this.selectedCountryDDI.changeMask = true
                }, 1000);
                
                setTimeout(() => {
                    document.getElementById('phoneNumber').focus()
                }, 1050);
            },

            dropListCountryCompany(status){
                setTimeout(() => {
                    this.listCountryCompanyStatus = status
                }, 250)
                
                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.countryCompany = true
                        document.getElementById('residenceCompanyCountry').focus()
                    }, 10);
                } else {
                    this.dropListOpened.countryCompany = false
                }
            },
            
            dropListCountry(status){
                setTimeout(() => {
                    this.listCountryStatus = status
                }, 250)
                
                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.countryPerson = true
                        document.getElementById('residenceCountry').focus()
                    }, 10);
                } else {
                    this.dropListOpened.countryPerson = false
                }
            },
            
            dropListLanguages(status){
                setTimeout(() => {
                    this.listLanguagesStatus = status
                }, 250)

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.languagePerson = true
                        document.getElementById('languageID').focus()
                    }, 10);
                } else {
                    this.dropListOpened.languagePerson = false
                }
            },
            
            dropListLanguagesCompany(status){
                setTimeout(() => {
                    this.listLanguagesCompanyStatus = status
                }, 250);

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.languageCompany = true
                        document.getElementById('languageCompanyID').focus()
                    }, 10);
                } else {
                    this.dropListOpened.languageCompany = false
                }
            },
            
            dropListDDICompany(status){
                setTimeout(() => {
                    this.selectedCountryDDICompany.openSelect = status
                }, 250);

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.ddiCompany = true
                    }, 10);
                } else {
                    this.dropListOpened.ddiCompany = false
                }
            },
            
            dropListDDI(status){
                setTimeout(() => {
                    this.selectedCountryDDI.openSelect = status
                }, 250);

                if ( status ){
                    setTimeout(() => {
                        this.dropListOpened.ddiPerson = true
                    }, 10);
                } else {
                    this.dropListOpened.ddiPerson = false
                }
            },

            filterListLanguageCompany() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("languageCompanyID");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list-company");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },

            filterListLanguage() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("languageID");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },

            filterListCountryCompany() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("residenceCompanyCountry");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },
            
            filterListCountry() {
                var input, filter, ul, li, a, i, txtValue;
                input = document.getElementById("residenceCountry");
                filter = input.value.toUpperCase();
                ul = document.getElementById("drop-list");
                li = ul.getElementsByTagName("li");
                for (i = 0; i < li.length; i++) {
                a = li[i].getElementsByTagName("a")[0];
                txtValue = a.textContent || a.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                        li[i].style.display = "";
                } else {
                        li[i].style.display = "none";
                }
                }
            },

            validationFormInvite(){

                // VALIDATION COMPLIANCE
                if ( this.dataInvite.invite_type_code === "company_invite" ){

                    // COMPANY NAME
                    if ( this.newInvite.companyInvite.fullName != "" ){
                        var companyName = this.newInvite.companyInvite.fullName
                        companyName = companyName.trim().split(' ').length
                        
                        if ( companyName < 2 ){
                            this.errorForm.companyInvite.fullName = true
                        } else {
                            this.errorForm.companyInvite.fullName = false
                        }
                    } else {
                        this.errorForm.companyInvite.fullName = true
                    }

                    // COMPANY EMAIL
                    if ( this.newInvite.companyInvite.email === "" ){
                        this.errorForm.companyInvite.email = true
                    } else {
                        this.errorForm.companyInvite.email = false
                    }

                    // COMPANY LANGUAGE
                    if ( this.newInvite.companyInvite.languageId === "" ){
                        this.errorForm.companyInvite.languageId = true
                    } else {
                        this.errorForm.companyInvite.languageId = false
                    }

                    // COMPANY COUNTRY
                    if ( this.newInvite.companyInvite.countryId === "" ){
                        this.errorForm.companyInvite.countryId = true
                    } else {
                        this.errorForm.companyInvite.countryId = false
                    }

                    // COMPANY PHONE
                    if ( this.validatePhone.company.val === "" ){
                        this.errorForm.companyInvite.phoneNumber = true
                    } else if ( this.validatePhone.company.val.length < this.selectedCountryDDICompany.phoneMask.length ) {
                        this.errorForm.companyInvite.phoneNumber = true
                    } else {
                        this.errorForm.companyInvite.phoneNumber = false
                    }

                    // COMPANY TAXNUMBER
                    if ( this.newInvite.companyInvite.taxNumber ==="" ){
                        this.errorForm.companyInvite.taxNumber = true
                    } else {
                        this.errorForm.companyInvite.taxNumber = false
                    }

                    // CKECK VALIDATION COMPLIANCE
                    if ( this.errorForm.companyInvite.fullName || this.errorForm.companyInvite.email || this.errorForm.companyInvite.languageId || this.errorForm.companyInvite.countryId || this.errorForm.companyInvite.phoneNumber || this.errorForm.companyInvite.taxNumber ){
                        window.location.href = "#!company"
                        this.errorForm.company = true
                    } else {
                        this.errorForm.company = false
                    }
                }
                
                // PERSON NAME
                if ( this.newInvite.fullName != "" ){
                    var personName = this.newInvite.fullName
                    personName = personName.trim().split(' ').length
                    
                    if ( personName < 2 ){
                        this.errorForm.personInvite.fullName = true
                    } else {
                        this.errorForm.personInvite.fullName = false
                    }
                } else {
                    this.errorForm.personInvite.fullName = true
                }

                // EMAIL
                if ( this.newInvite.email === "" ){
                    this.errorForm.personInvite.email = true
                } else {
                    this.errorForm.personInvite.email = false
                }

                // LANGUAGE
                if ( this.newInvite.languageId === "" ){
                    this.errorForm.personInvite.languageId = true
                } else {
                    this.errorForm.personInvite.languageId = false
                }

                // COUNTRY
                if ( this.newInvite.countryId === "" ){
                    this.errorForm.personInvite.countryId = true
                } else {
                    this.errorForm.personInvite.countryId = false
                }

                // PHONE
                if ( this.validatePhone.person.val === "" ){
                    this.errorForm.personInvite.phoneNumber = true
                } else if ( this.validatePhone.person.val.length < this.selectedCountryDDI.phoneMask.length ) {
                    this.errorForm.personInvite.phoneNumber = true
                } else {
                    this.errorForm.personInvite.phoneNumber = false
                }

                // ACCEPTS
                if ( !this.accept.terms ){
                    this.errorForm.acceptsInvite.acceptTerms = true
                } else{
                    this.errorForm.acceptsInvite.acceptTerms = false
                }
                
                if ( !this.accept.notify ){
                    this.errorForm.acceptsInvite.acceptNotify = true
                } else{
                    this.errorForm.acceptsInvite.acceptNotify = false
                }
                
                if ( !this.accept.gdpr ){
                    this.errorForm.acceptsInvite.acceptGdpr = true
                } else{
                    this.errorForm.acceptsInvite.acceptGdpr = false
                }

                if ( this.errorForm.acceptsInvite.acceptTerms || this.errorForm.acceptsInvite.acceptNotify || this.errorForm.acceptsInvite.acceptGdpr ){
                    this.errorForm.accepts = true
                } else {
                    this.errorForm.accepts = false
                }


                // CKECK VALIDATION COMPLIANCE
                if ( !this.errorForm.company && (this.errorForm.personInvite.fullName || this.errorForm.personInvite.email || this.errorForm.personInvite.languageId || this.errorForm.personInvite.countryId || this.errorForm.personInvite.phoneNumber) ){
                    window.location.href = "#!person"
                    this.errorForm.person = true
                } else {
                    this.errorForm.person = false
                }

                // LAST CKECK
                if ( !this.errorForm.company && !this.errorForm.accepts && !this.errorForm.person ){
                    this.register()
                }
            },
            
            register(){
                this.load = true
                const register = this.newInvite;

                let dataPhoneCompany = this.validatePhone.company.val
                let dataPhonePerson = this.validatePhone.person.val

                this.newInvite.companyInvite.phoneNumber = dataPhoneCompany.replace(/[^0-9]/g,'')
                this.newInvite.phoneNumber = dataPhonePerson.replace(/[^0-9]/g,'')
                
                apiPlatform.post(`/api/v1/platform/account/invite/${this.newInvite.inviteId}`, register)
                .then(response => {
                    this.registerId = response.data.id;
                    const languageRedirect = String(window.location.pathname).split("/")[1];
                    window.location.href = `/${languageRedirect}/account/confirm-email-invite/${this.$route.params.registerId}`
                })
                .catch(error => {
                    console.log(error.response.data)

                    if ( error.response.data === "account_activate_email_already_exists" || error.response.data === "account_activate_phone_already_exists" || error.response.data === "not_allowed_restricted_country_pep" ) {
                        this.errorsPost.newInvite = error.response.data
                    } else{
                        this.errorsPost.general = error.response.status

                        setTimeout(() => {
                            this.errorsPost.general = false
                        }, 10000);
                    }

                    console.log(this.errorsPost)

                    setTimeout(() => {
                        this.load = false
                    }, 500);
                })
            },

            // register(){
            //     let dataPhoneCompany = this.validatePhone.company.val
            //     let dataPhonePerson = this.validatePhone.person.val

            //     this.newInvite.companyInvite.phoneNumber = dataPhoneCompany.replace(/[^0-9]/g,'')
            //     this.newInvite.phoneNumber = dataPhonePerson.replace(/[^0-9]/g,'')

            //     console.log(this.newInvite)
            // },


            resendMsg(type){
                this.resendLoad = true

                apiPlatform.post("/api/v1/platform/account/confirm/resend", {"inviteId": this.$route.params.registerId, "messageType": type})
                .then(response => {
                    console.log(response)
                    console.clear()

                    if ( type == "sms" ){
                        this.$toast.success(this.getMyLanguage("sms","sms.sent"));
                    } else{
                        this.$toast.success(this.getMyLanguage("confirm-email","confirm-email-invite.email-resend"));
                    }

                    setTimeout(() => {
                        this.resendLoad = false
                        setTimeout(this.$toast.clear, 6000)
                    }, 1000);
                })
                .catch(error => {
                    console.log(error)
                    
                    this.$toast.success(this.getMyLanguage("box-error","general-error"));
                    
                    setTimeout(() => {
                        this.resendLoad = false
                        setTimeout(this.$toast.clear, 6000)
                    }, 1000);
                })
                
            }
        },

        watch: {
            '$store.state.SelectLanguage.code': {
                immediate: true,
                handler() {
                    this.languageSelected();
                    this.orderLangs()
                    this.ordercountries()
                }
            }
        },

        created () {
            document.title = this.getMyLanguage("seo","title.account.invite");
            document.getElementsByTagName('meta')["description"].content = ''
            document.head.querySelector('meta[name=robots]').content = 'noindex, nofollow'
        },
    }
</script>

<style src="./custom-invite.scss" lang="scss" scoped />